import React, { useState } from 'react';
import { useBilling } from '../../../contexts/BillingContext';
import { formatDateTime } from '../../../utils/billingMoney';
import { BusinessSettings } from './BusinessSettings';
import { RegionalSettings } from './RegionalSettings';
import { NumberingSettings } from './NumberingSettings';
import { ItemsPricingSettings } from './ItemsPricingSettings';
import { TaxSettings } from './TaxSettings';
import { SalesSettings } from './SalesSettings';
import { PaymentSettings } from './PaymentSettings';
import { DocumentSettings } from './DocumentSettings';
import { PermissionsSettings } from './PermissionsSettings';
import { EmailRecurringSettings } from './EmailRecurringSettings';
import { DataSettings } from './DataSettings';
const sections = [{
  id: 'business',
  label: 'Business & branding',
  el: BusinessSettings
}, {
  id: 'regional',
  label: 'Regional & reporting',
  el: RegionalSettings
}, {
  id: 'numbering',
  label: 'Document numbering',
  el: NumberingSettings
}, {
  id: 'items',
  label: 'Items & pricing',
  el: ItemsPricingSettings
}, {
  id: 'tax',
  label: 'Tax',
  el: TaxSettings
}, {
  id: 'sales',
  label: 'Invoices & direct sales',
  el: SalesSettings
}, {
  id: 'payments',
  label: 'Payments',
  el: PaymentSettings
}, {
  id: 'documents',
  label: 'Printing & documents',
  el: DocumentSettings
}, {
  id: 'permissions',
  label: 'Users, permissions & audit',
  el: PermissionsSettings
}, {
  id: 'email',
  label: 'Email, reminders & recurring',
  el: EmailRecurringSettings
}, {
  id: 'data',
  label: 'Data & integrations',
  el: DataSettings
}] as const;

/** Express-Invoice-style settings workspace: section list on the left, one section at a time. */
export function BillingSettingsPage() {
  const {
    config
  } = useBilling();
  const [active, setActive] = useState<(typeof sections)[number]['id']>('business');
  const Section = sections.find(s => s.id === active)!.el;
  return <div className="space-y-3" data-id="element-5221" data-mp="2wura8krjwmaz">
      <div className="flex flex-wrap items-baseline justify-between gap-2" data-id="element-5222" data-mp="2wtg5ahmdd8ia">
        <h1 className="text-xl font-bold text-slate-900" data-id="element-5223" data-mp="uwfiddsey5si">Billing Settings</h1>
        {config.updatedAt && <p className="text-xs text-slate-500" data-id="element-5224" data-mp="yz2brj4qfyrt">Last changed {formatDateTime(config.updatedAt)} by {config.updatedByName}</p>}
      </div>
      <div className="grid gap-4 lg:grid-cols-[220px_minmax(0,1fr)]" data-id="element-5225" data-mp="l6mgj4i2p51g">
        <nav aria-label="Settings sections" className="lg:sticky lg:top-24 lg:self-start" data-id="element-5226" data-mp="q5fibznzz7ls">
          <ul className="flex gap-1 overflow-x-auto rounded-lg border border-slate-200 bg-white p-1.5 lg:flex-col" data-id="element-5227" data-mp="b8gg6rbx06yp">
            {sections.map(s => <li key={s.id} data-id="element-5228" data-mp="g5yezow7x5sz">
                <button type="button" onClick={() => setActive(s.id)} aria-current={active === s.id ? 'page' : undefined} className={`w-full whitespace-nowrap rounded-md px-3 py-2 text-left text-sm font-medium ${active === s.id ? 'bg-indigo-50 text-indigo-800' : 'text-slate-700 hover:bg-slate-50'}`} data-id="element-5229" data-mp="28jnmememnyd">{s.label}</button>
              </li>)}
          </ul>
        </nav>
        <div className="min-w-0" data-id="element-5230" data-mp="21j1kqmivb5p9"><Section key={active} data-id="element-5231" data-mp="2bp2q2r3t1fk2" /></div>
      </div>
    </div>;
}